<h2  class="mt-5">{{cardConfiguration.title}}</h2>

<fieldset *ngIf="isVersion2()" [disabled]="isWorkflowOnSubscriber">
  <div class="row">
    <div *ngIf="checkVisibilityRemunerationPosition()" class="col-sm-3">
      <div class="form-group">
        <label for="RemunerationPosition">
          <span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}"></span>
        </label>

        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}"
               [(ngModel)]="cardData.remunerationPosition" name="remunerationPosition" #remunerationPosition="ngModel" maxlength="3" required>
        <validation-message [control]="remunerationPosition"></validation-message>
      </div>
    </div>

    <div *ngIf="checkVisibilityRemunerationLevel()" class="col-sm-3">
      <div class="form-group">
        <label for="RemunerationLevel">
          <span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}"></span>
        </label>

        <input class="form-control" type="text" numeric="3.2"
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}"
               [(ngModel)]="cardData.remunerationLevel" name="remunerationLevel" #remunerationLevel="ngModel" maxValue="115" required>
        <validation-message [control]="remunerationLevel"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="BaseRevenue"><span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.BaseRevenue' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.baseRevenue" name="baseRevenue" #baseRevenue="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="baseRevenue"></validation-message>
        </div>
      </div>
    </div>


  </div>
  <div class="row" >
    <div class="col-sm-4" *ngIf="cardData.hasChristmasBenefit !== undefined ">
      <div class="form-group">
        <label for="HasChristmasBenefit">
          <span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.HasChristmasBenefit' | translate}}
        </label>

        <div class="btn-group btn-group-toggle " style="padding-left:0 !important">
          <label *ngFor="let domain of yesNo.slice().reverse()"
                 tabindex="0" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasChristmasBenefit"
                 [radioLabel]="hasChristmasBenefit">
            <input type="radio" [(ngModel)]="cardData.hasChristmasBenefit" name="hasChristmasBenefit" #hasChristmasBenefit="ngModel" [value]="domain.value" required (change)="hasChristmasBenefitChanged()">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4 ">
      <div class="form-group">
        <fieldset [disabled]="cardData.hasChristmasBenefit !==undefined && cardData.hasChristmasBenefit !== 'true' ">
          <label for="ChristmasBenefitAmount">
            <span class="mandatory" *ngIf="cardData.hasChristmasBenefit !== undefined && cardData.hasChristmasBenefit === 'true'">*</span>{{'CardRemunerationsCurrentMonthly.ChristmasBenefitAmount' | translate}}
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.ChristmasBenefitAmount' | translate}}"></span>
          </label>
          <div class="position-relative">
            <input class="form-control input-left" type="text" currency 
                   placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                   [(ngModel)]="cardData.christmasBenefitAmount" name="christmasBenefitAmount" #christmasBenefitAmount="ngModel"
                   [required]="cardData.hasChristmasBenefit !== undefined && cardData.hasChristmasBenefit === 'true'" maxValue="999000" minValue="0.01" messageFieldType="currency">
            <span class="input-icon-span-left">€</span>
            <validation-message [control]="christmasBenefitAmount"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="row">
    <!--Ínicio Categoria-->
    <div *ngIf="(professionalClass !== '5' && professionalClass !== '4' && professionalClass !== '17') || checkCGDStarterEntity() || isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="CategoryM"><span class="mandatory">*</span>Categoria</label>
        <input class="form-control" type="text"
               required
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.Category' | translate}}"
               [(ngModel)]="cardData.categoryM" name="categoryM" #categoryM="ngModel" maxlength="50">
        <validation-message [control]="categoryM"></validation-message>
      </div>

    </div>

    <div *ngIf="(professionalClass === '5' || professionalClass === '4' || professionalClass === '17') && !checkCGDStarterEntity() && !isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="CategoryM">
          <span class="mandatory">*</span>
          Categoria
        </label>
        <select class="custom-select" [(ngModel)]="cardData.categoryM" name="categoryM"
                #categoryM="ngModel"
                required
                (ngModelChange)="changedCategoryM($event)"
                [clearRelated]="{model : this.cardData , propsToReset : ['taxIndexM', 'earningsTableIndexM']}"
                [dropdownTitle]="{value : cardData.categoryM }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of categories" [value]="domain.description">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="categoryM"></validation-message>
      </div>
    </div>
    <!--Fim Categoria-->
    <!--Ínicio Nível-->
    <div *ngIf="checkCGDStarterEntity() && !isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="TaxLevelM">
          <span class="mandatory">*</span>
          Nível
        </label>
        <select class="custom-select" [(ngModel)]="cardData.taxLevelM" name="taxLevelM"
                #taxLevelM="ngModel"
                (ngModelChange)="changedTaxLevelsM($event)"
                required
                [clearRelated]="{model : this.cardData , propsToReset : ['earningsTableIndexM']}"
                [dropdownTitle]="{value : cardData.taxLevelM }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of levels" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="taxLevelM"></validation-message>
      </div>
    </div>
    <div *ngIf="isExSubscritor && checkVisibilityTaxLevelM()" class="col-sm-4">
      <div class="form-group">
        <label for="TaxLevelM">
          <span class="mandatory">*</span>
          Nível
        </label>
        <input class="form-control" type="text"
               required
               placeholder="Indique o nível"
               [(ngModel)]="cardData.taxLevelM" name="taxLevelM" #categoryM="ngModel" !>
        <validation-message [control]="taxLevelM"></validation-message>
      </div>
    </div>
    <!--Fim Nível-->
    <!--Ínicio Escalão-->
    <!--<div *ngIf="professionalClass !== '5' && professionalClass !== '4' && professionalClass !== '17' && !checkCGDStarterEntity()" class="col-sm-4">
    <div class="form-group">
      <label for="EarningsTableIndexM">
        Escalão de tabela de vencimentos
      </label>
      <input class="form-control" type="text"
              placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.TaxStep' | translate}}"
              [(ngModel)]="cardData.earningsTableIndexM" name="earningsTableIndexM" #earningsTableIndexM="ngModel" maxlength="40">
      <validation-message [control]="earningsTableIndexM"></validation-message>
    </div>
  </div>-->
    <div *ngIf="!checkCGDStarterEntity() && (professionalClass === '5' || professionalClass === '4') && !isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="EarningsTableIndexM">
          <span *ngIf="cardData.categoryM !== undefined || cardData.taxLevelM !== undefined" class="mandatory">*</span>
          Escalão de tabela de vencimentos
        </label>
        <select class="custom-select" [(ngModel)]="cardData.earningsTableIndexM" name="earningsTableIndexM"
                #earningsTableIndexM="ngModel"
                (ngModelChange)="changedTaxSteps($event)"
                [disabled]="cardData.categoryM === undefined"
                [required]="cardData.categoryM !== undefined || cardData.taxLevelM !== undefined"
                [dropdownTitle]="{value : cardData.earningsTableIndexM }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of taxSteps" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="earningsTableIndexM"></validation-message>
      </div>
    </div>

    <div *ngIf="checkCGDStarterEntity() && !isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="EarningsTableIndexM" [class.disabled]="cardData.taxLevelM === undefined">
          <span *ngIf="cardData.taxLevelM !== undefined" class="mandatory">*</span>
          Escalão de tabela de vencimentos
        </label>
        <select class="custom-select" [(ngModel)]="cardData.earningsTableIndexM" name="earningsTableIndexM"
                #earningsTableIndexM="ngModel"
                (ngModelChange)="changedTaxSteps($event)"
                [disabled]="cardData.taxLevelM === undefined"
                [required]="cardData.taxLevelM !== undefined"
                [dropdownTitle]="{value : cardData.earningsTableIndexM }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of taxSteps" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="earningsTableIndexM"></validation-message>
      </div>
    </div>

    <div *ngIf="isExSubscritor && checkVisibilityEarningsTableIndexM()" class="col-sm-4">
      <div class="form-group">
        <label for="EarningsTableIndexM">
          <span class="mandatory">*</span>
          Escalão de tabela de vencimentos
        </label>
        <input class="form-control" type="text"
                required
                placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.TaxStep' | translate}}"
                [(ngModel)]="cardData.earningsTableIndexM" name="earningsTableIndexM" #earningsTableIndexM="ngModel" maxlength="50">
        <validation-message [control]="earningsTableIndexM"></validation-message>
      </div>
    </div>
    <!--Fim Escalão-->
    <!--Ínicio Índice-->
    <div *ngIf="(professionalClass === '5' || professionalClass === '4') && !checkCGDStarterEntity() && !isExSubscritor" class="col-sm-4">
      <div class="form-group">
        <label for="TaxIndexM" [class.disabled]="cardData.earningsTableIndexM === undefined">
          <span *ngIf="cardData.earningsTableIndexM !== undefined" class="mandatory">*</span>
          {{'CardRemunerationsCurrentMonthly.TaxIndex' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.taxIndexM" name="taxIndexM"
                #taxIndexM="ngModel"
                required
                [dropdownTitle]="{value : cardData.taxIndexM }"
                [disabled]="cardData.earningsTableIndexM === undefined"
                [required]="cardData.earningsTableIndexM !== undefined"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of taxIndexes" [value]="domain.description">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="taxIndexM"></validation-message>
      </div>
    </div>
    <div *ngIf="isExSubscritor && checkVisibilityTaxIndexM()" class="col-sm-4">
      <div class="form-group">
        <label for="taxIndexM">
          <span class="mandatory">*</span>
          {{'CardRemunerationsCurrentMonthly.TaxIndex' | translate}}
        </label>
        <input class="form-control" type="text" maxlength="40" required
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.TaxIndex' | translate}}"
               [(ngModel)]="cardData.taxIndexM" name="taxIndexM" #taxIndexM="ngModel">
        <validation-message [control]="taxIndexM"></validation-message>
      </div>
    </div>
    <!--Fim Índice-->
    <!--Ínicio Letra-->
    <div *ngIf="isExSubscritor && checkVisibilityLetter()" class="col-sm-4">
      <div class="form-group">
        <label for="letter ">
          <span class="mandatory">*</span>
          {{'CardRemunerationsCurrentMonthly.Letter' | translate}}
        </label>
        <input class="form-control" type="text" maxlength="2" required
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.Letter' | translate}}"
               [(ngModel)]="cardData.letter" name="letter" #letter="ngModel">
        <validation-message [control]="letter"></validation-message>
      </div>
    </div>
    <!--Fim Letra-->
  </div>
  

  <div class="row d-flex align-items-center">
    <div class="col-sm-8">
      <h3 class="mb-0">
        {{'CardRemunerationsCurrentMonthly.OtherRemunerations' | translate}}
      </h3>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Novo entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>


  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.AddItem' | translate}}</h3>
    <remuneration-other-table-edit [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.Designation' | translate}}</th>
        <th scope="col">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.Start' | translate}}</th>
        <th scope="col">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.Value' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td class=" align-items-center">
            <i rowExternalValidation="remunerationsList" [tableIndex]="i"></i>
            {{tableItem.suplementDescription}}
          </td>
          <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
          <td *ngIf="tableItem.renumerationType !== 'B'"> {{currencyFormat(tableItem.remunerationValue)}} €</td>
          <td *ngIf="tableItem.renumerationType === 'B'">(...)</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
            </button>
            <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList , i,$event)">
              <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="4" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <remuneration-other-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>

<fieldset *ngIf="!isVersion2()" [disabled]="isWorkflowOnSubscriber">
  <div class="row">
    <div class="col-sm-3">
      <div class="form-group">
        <label for="RemunerationPosition">
          {{'CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}"></span>
        </label>

        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.RemunerationPosition' | translate}}"
               [(ngModel)]="cardData.remunerationPosition" name="remunerationPosition" #remunerationPosition="ngModel" maxlength="3">
        <validation-message [control]="remunerationPosition"></validation-message>
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <label for="RemunerationPosition">
          {{'CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}"></span>
        </label>

        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardRemunerationsCurrentMonthly.RemunerationLevel' | translate}}"
               [(ngModel)]="cardData.remunerationLevel" name="remunerationLevel" #remunerationLevel="ngModel" maxlength="3">
        <validation-message [control]="remunerationLevel"></validation-message>
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <label for="BaseRevenue"><span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.BaseRevenue' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.baseRevenue" name="baseRevenue" #baseRevenue="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="baseRevenue"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <label for="ChristmasBenefitAmount">
          <span class="mandatory">*</span>{{'CardRemunerationsCurrentMonthly.ChristmasBenefitAmount' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsCurrentMonthly.ChristmasBenefitAmount' | translate}}"></span>
        </label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.christmasBenefitAmount" name="christmasBenefitAmount" #christmasBenefitAmount="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="christmasBenefitAmount"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-center">
    <div class="col-sm-8">
      <h3 class="mb-0">
        {{'CardRemunerationsCurrentMonthly.OtherRemunerations' | translate}}
      </h3>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Novo entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>


  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.AddItem' | translate}}</h3>
    <remuneration-other-table-edit [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Designação de Remuneração</th>
        <th scope="col">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.Start' | translate}}</th>
        <th scope="col">{{'CardRemunerationsCurrentMonthly.RemunerationsOtherTable.Value' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td>{{tableItem.designation}}</td>
          <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
          <td>{{currencyFormat(tableItem.remunerationValue)}} €</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
            </button>
            <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList , i,$event)">
              <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="4" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <remuneration-other-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->
